/*
  AGNTC 2026-08-14 — NOOD size finder.
  Paired with sections/agntc-size-calculator.liquid.

  The lookup table is the source of truth; the arithmetic only ever feeds into
  it. See the section's header comment for why that separation matters.
*/
(function () {
  'use strict';

  function parseMap(raw) {
    // "1|30B,30C\n2|30DD,..."  ->  { '30B': '1', '30DD': '2', ... }
    var out = {};
    // newline OR semicolon: the page section stores this in a textarea (real
    // newlines) while the PDP snippet must pass it on one line, because a
    // {% liquid %} tag parses every line as a separate tag.
    String(raw || '').split(/[\n;]+/).forEach(function (line) {
      var bits = line.split('|');
      if (bits.length < 2) return;
      var size = bits[0].trim();
      bits[1].split(',').forEach(function (bra) {
        var k = bra.trim().toUpperCase();
        if (k) out[k] = size;
      });
    });
    return out;
  }

  function bandsFrom(map) {
    var s = {};
    Object.keys(map).forEach(function (k) { var m = k.match(/^(\d+)/); if (m) s[m[1]] = 1; });
    return Object.keys(s).map(Number).sort(function (a, b) { return a - b; });
  }
  function cupsFrom(map, order) {
    var present = {};
    Object.keys(map).forEach(function (k) { var m = k.match(/^\d+(.+)$/); if (m) present[m[1].toUpperCase()] = 1; });
    // keep the merchant's order, drop anything the table never uses
    return order.filter(function (c) { return present[c.toUpperCase()]; });
  }

  /*
    NOOD's charts print several cup rows under two names at once - "DD/E", "DDD/F",
    "DDDD/G", "AA/A". The lookup needs ONE key per row and the measurement ladder needs
    exactly one entry per inch, so the second name cannot live in either. It lives here,
    as display text only: the shopper reads the same label the chart prints, and the
    value posted to the lookup is unchanged.
    Format: `VALUE=Label` pairs, comma separated. Anything unlisted shows as itself.
  */
  function labelsFrom(raw) {
    var out = {};
    String(raw || '').split(',').forEach(function (pair) {
      var i = pair.indexOf('=');
      if (i < 1) return;
      out[pair.slice(0, i).trim().toUpperCase()] = pair.slice(i + 1).trim();
    });
    return out;
  }

  function init(root) {
    if (root._scBound) return;
    root._scBound = true;

    var mapEl = root.querySelector('[data-sc-map]');
    var cfgEl = root.querySelector('[data-sc-config]');
    if (!mapEl || !cfgEl) return;

    var map, cfg;
    try { map = parseMap(JSON.parse(mapEl.textContent)); } catch (e) { return; }
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = {}; }

    var CUPS = String(cfg.cupOrder || 'A,B,C,D,DD,DDD,DDDD,H,I,J,K').split(',').map(function (s) { return s.trim(); });
    var PRODUCT = cfg.productName || 'Game Changer';

    var bandSel = root.querySelector('[data-sc-band]');
    var cupSel = root.querySelector('[data-sc-cup]');
    var under = root.querySelector('[data-sc-under]');
    var bust = root.querySelector('[data-sc-bust]');
    var errEl = root.querySelector('[data-sc-error]');
    var resEl = root.querySelector('[data-sc-result]');
    var eyebrow = root.querySelector('[data-sc-eyebrow]');
    var sizeEl = root.querySelector('[data-sc-size]');
    var noteEl = root.querySelector('[data-sc-note]');
    var units = 'in';

    // Populate the dropdowns FROM THE TABLE, so an option can never exist that
    // the table cannot answer.
    var bands = bandsFrom(map);
    var cups = cupsFrom(map, CUPS);
    bandSel.innerHTML = '<option value="">Select</option>' + bands.map(function (b) { return '<option value="' + b + '">' + b + '</option>'; }).join('');
    var CUPLABELS = labelsFrom(cfg.cupLabels);
    cupSel.innerHTML = '<option value="">Select</option>' + cups.map(function (c) { return '<option value="' + c + '">' + (CUPLABELS[c.toUpperCase()] || c) + '</option>'; }).join('');

    function show(err) {
      errEl.textContent = err || '';
      errEl.hidden = !err;
      if (err) resEl.hidden = true;
    }

    /*
      On the product page the answer is only half the job — Astrid asked for it to
      tell them "their exact size AND the product they're looking at". So when the
      resolved size is one this product actually sells, offer to select it, and
      when it is not, say so plainly and point at the style that does go that far
      (which is NOOD's own guidance: the Shape Up chart's `*` cells read "Check out
      our full bust options such as the Game Changer").
    */
    function selectOnPage(size) {
      var name = cfg.sizeOptionName || 'Size';
      var hit = null;
      /*
        AGNTC 2026-09-23 - look in the finder's OWN section first, then the page.
        The Game Changer page carries two finders: the buy box's, and the one in
        the Pro Stylist Kit feature further down. Searching the whole document
        first meant the KIT finder found the buy box's Size radios before its own
        chips, so "Select size 2" in the kit section moved the Game Changer's size
        and left the kit's own chips (and the kit's posted id) on the old size.
        The document-wide pass below is the old behaviour, kept as the fallback.
      */
      var own = root.closest('.shopify-section') || document;
      hit = findIn(own, size, name);
      if (!hit && own !== document) hit = findIn(document, size, name);
      if (!hit) return false;

      /*
        AGNTC 2026-09-23 - the size finder was sending the OLD size to the cart.
        This used to set hit.checked = true and THEN click the label. Clicking the
        label of a radio that is already checked changes nothing, so the browser
        fires no change event, and the theme's variant logic (variant-radios in
        global.js, the kit feature's own chip listener, the mobile sticky bar) all
        listen for change. The radio showed the new size while the form's variant
        id, ?variant= and the sticky bar stayed on the old one, and Add to Bag
        posted the old size.
        Now: click the label while the radio is still UNchecked, which is exactly
        a shopper's tap, so the browser checks it and fires change itself. Label
        activation is synchronous, so we know straight after whether change ran;
        if it did not (the radio was already the checked one, or a script ate the
        click), check it and fire change ourselves so the theme always re-syncs.
      */
      var fired = false;
      var mark = function () { fired = true; };
      hit.addEventListener('change', mark);
      var label = hit.closest('label') || (hit.id ? document.querySelector('label[for="' + hit.id + '"]') : null);
      if (label && !hit.checked) label.click();
      hit.removeEventListener('change', mark);
      if (!hit.checked) hit.checked = true;
      if (!fired) hit.dispatchEvent(new Event('change', { bubbles: true }));
      var fs = hit.closest('fieldset, .product-form__input');
      if (fs && fs.scrollIntoView) fs.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return true;
    }

    function findIn(scope, size, name) {
      var hit = null;
      // The PDP renders options as radios inside label.customradio[data-name].
      scope.querySelectorAll('.option-grid input[type="radio"]').forEach(function (input) {
        if (hit) return;
        if (String(input.value).trim() !== String(size).trim()) return;
        var fs = input.closest('fieldset, .product-form__input');
        var legend = fs ? (fs.querySelector('legend, .form__label') || {}).textContent || '' : '';
        if (legend.toLowerCase().indexOf(String(name).toLowerCase()) === -1) return;
        hit = input;
      });
      /*
        The kit feature section renders its own chips rather than the PDP's
        option grid, so the finder embedded in it found nothing to select and
        silently reported failure. Same contract: match the value, and confirm
        the group is the Size option and not Colors.
      */
      if (!hit) {
        scope.querySelectorAll('[data-kf-value]').forEach(function (input) {
          if (hit) return;
          if (String(input.value).trim() !== String(size).trim()) return;
          var grp = input.closest('[data-kf-opt]');
          if (!grp) return;
          var lbl = (grp.querySelector('.agntc-kf-opt-label') || {}).textContent || '';
          if (lbl.toLowerCase().indexOf(String(name).toLowerCase()) === -1) return;
          hit = input;
        });
      }
      return hit;
    }

    var applyBtn = root.querySelector('[data-sc-apply]');
    var altLink = root.querySelector('[data-sc-alt]');

    function present(bra, estimated) {
      var size = map[bra.toUpperCase()];

      if (!size) {
        // On a PDP an unmapped size is meaningful: this style does not go that far.
        if (cfg.applyToProduct) {
          show('');
          eyebrow.textContent = estimated ? 'You measure about a ' + bra : 'For a ' + bra;
          sizeEl.textContent = 'Not in this style';
          noteEl.textContent = cfg.outOfRangeMessage || 'This style does not go up to your size.';
          if (applyBtn) applyBtn.hidden = true;
          if (altLink) altLink.hidden = false;
          resEl.hidden = false;
          return;
        }
        show('We don’t have a ' + bra + ' in the ' + PRODUCT + ' chart. Try the size either side, or ask us and we’ll help.');
        return;
      }

      show('');
      eyebrow.textContent = estimated ? 'You measure about a ' + bra : 'For a ' + bra;
      sizeEl.textContent = cfg.applyToProduct ? ('Your size: ' + size) : (PRODUCT + ' Size ' + size);
      /*
        2026-09-22: `resultNote` is optional config (agntc-size-calculator's "Result note"
        setting). The default line talks about trimming a BRA, which is wrong on a
        nipple-cover or tape page. Absent = the original strings, unchanged.
      */
      var sizeNote = cfg.resultNote || 'In between sizes? Size up, the bra can be trimmed smaller.';
      noteEl.textContent = estimated
        ? 'Measurements are a guide. ' + sizeNote
        : sizeNote;
      if (altLink) altLink.hidden = true;

      if (applyBtn) {
        /*
          applyToProduct false means there is no option picker on the page to
          drive (the V5 homepage kit block ends at a link). Offering "Select
          size N" there would be a dead click, so the readout is the whole
          answer and the button stays hidden.
        */
        var sells = cfg.applyToProduct !== false
          && (cfg.availableSizes || []).some(function (v) { return String(v).trim() === String(size).trim(); });
        applyBtn.hidden = !sells;
        if (sells) {
          applyBtn.textContent = 'Select size ' + size;
          applyBtn.onclick = function () {
            if (selectOnPage(size)) { applyBtn.textContent = 'Size ' + size + ' selected'; applyBtn.disabled = true; }
          };
          applyBtn.disabled = false;
        }
      }
      resEl.hidden = false;
    }

    function fromKnown() {
      var b = bandSel.value, c = cupSel.value;
      if (!b || !c) { resEl.hidden = true; show(''); return; }
      present(b + c, false);
    }

    function toInches(v) { return units === 'cm' ? v / 2.54 : v; }

    function fromMeasure() {
      var u = parseFloat(String(under.value).replace(',', '.'));
      var t = parseFloat(String(bust.value).replace(',', '.'));
      if (!under.value || !bust.value) { resEl.hidden = true; show(''); return; }
      if (isNaN(u) || isNaN(t)) { show('Please enter numbers for both measurements.'); return; }

      u = toInches(u); t = toInches(t);
      if (u < 20 || u > 60 || t < 20 || t > 70) { show('Those measurements look off — please check them.'); return; }
      if (t <= u) { show('Your bust measurement should be larger than your underbust.'); return; }

      // Band: underbust rounded to the nearest even number, then clamped to what
      // the table actually covers — a 29" underbust must not silently become a
      // band the chart has never heard of.
      var band = Math.round(u / 2) * 2;
      if (band < bands[0]) band = bands[0];
      if (band > bands[bands.length - 1]) band = bands[bands.length - 1];

      // Cup: each whole inch of difference is one cup step. Round rather than floor
      // so 3.6" reads as the next cup up rather than dropping most of an inch.
      var diff = Math.round(t - band);
      if (diff < 1) diff = 1;
      var cup = CUPS[diff - 1];
      if (!cup) cup = CUPS[CUPS.length - 1];

      present(band + cup, true);
    }

    bandSel.addEventListener('change', fromKnown);
    cupSel.addEventListener('change', fromKnown);
    [under, bust].forEach(function (el) { if (el) el.addEventListener('input', fromMeasure); });

    root.querySelectorAll('[data-sc-units]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        units = btn.getAttribute('data-sc-units');
        root.querySelectorAll('[data-sc-units]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        root.querySelectorAll('[data-sc-unit-label]').forEach(function (l) { l.textContent = units; });
        fromMeasure();
      });
    });

    root.querySelectorAll('[data-sc-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var name = tab.getAttribute('data-sc-tab');
        root.querySelectorAll('[data-sc-tab]').forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        root.querySelectorAll('[data-sc-panel]').forEach(function (p) {
          var on = p.getAttribute('data-sc-panel') === name;
          p.classList.toggle('is-active', on);
          p.hidden = !on;
        });
        resEl.hidden = true; show('');
        if (name === 'known') fromKnown(); else fromMeasure();
      });
    });
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-sc]').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  // Theme editor re-renders a section without firing DOMContentLoaded again.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target || document); });
})();
